export default __webpack_public_path__ + "static/media/icon-transaksi.e7ccadb3.png";